import { PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { createError } from '@sonar/errors';

import { Query, Result } from '../Reports/types';

import { failedOrderInfo, requestOrderInfo, succeededOrderInfo } from './reducer';
import { getOrdersPerStoreAsync } from './services';
import { OrderInfo } from './types';
import { overrideCanceledOrders } from './utils';

export function* getOrdersSaga({ payload: query }: PayloadAction<Query>): SagaIterator {
  try {
    const data = (yield call(getOrdersPerStoreAsync, query)) as Result<OrderInfo>;

    const result = overrideCanceledOrders(data);

    yield put(succeededOrderInfo(result));
  } catch (e) {
    yield put(failedOrderInfo({ storeIds: query.storeIds, error: createError(e) }));
  }
}

export default function* ordersWatcher(): SagaIterator {
  yield takeLatest(requestOrderInfo.type, getOrdersSaga);
}
